import SoundProps from "./Misc/SoundProps";
import Tools from "./Misc/Tools";
import $ from 'jquery';
import { Globals } from "../misc/helpers";
export default class SoundManager<SoundRefType> {
	public activeSounds: ActiveSound<SoundRefType>[] = [];
	public activeSoundIntervals: ActiveSoundInterval[] = [];
	public static currentCaption: string = null;
	public static hiddenCaption: boolean = false;
	public static mutedAudio: boolean = false;

	constructor(public onActiveSoundsUpdated: () => void) {
	}

	playSound(sound: SoundProps): void {
		if(Globals.skipAnimations) {
			if(sound.onEnded) {
				sound.onEnded();
			}

			return;
		}
		
		var context = this;
		var xhr = new XMLHttpRequest()
		xhr.onreadystatechange = function() {
			if (this.readyState === this.DONE) {
				context.playRawSound(sound);
			}
		}

		xhr.onerror = function() {
			if(sound.onEnded) { //if there is an error loading the sound, just call done method
				sound.onEnded();
			}
		}
		xhr.open('HEAD', sound.src); 
		xhr.send();
	}

	private playRawSound(sound: SoundProps) {
		var context = this;
		var id = Tools.generateGuid();
		(sound as any).id = id;
		(sound as any).soundManager = this;
		var props = {...sound};
		props.onEnded = () => {
			if(props.oneShot) {
				context.stopSound(id);
			}
			
			if(sound.onEnded) { 
				sound.onEnded();
			}
		};

		var reference = context.onAppendSoundToDOM(props);

		var activeSound: ActiveSound<any> = {
			id: id,
			currentCaption: null,
			reference: reference
		};
		var vttConfig: any = null;
		if (props.enableClosedCaptioning) {
			var vttPath = props.src.slice(0, -3) + "vtt";
			$.get(vttPath).then((result) => {
				context.convertVttToJson(result).then((r) => {
					var newInterval: ActiveSoundInterval = {
						id: id
					};
					vttConfig = r;
					var currentTime = 0;
					newInterval.interval = setInterval(() => {
						currentTime += 200;
						for (var indx = 0; indx < vttConfig.length; indx++) {
							if (
								vttConfig[indx].part &&
								!vttConfig[indx].done &&
								currentTime >= vttConfig[indx].start
							) {
								SoundManager.currentCaption = vttConfig[indx].part;
								vttConfig[indx].done = true;
								if (context.onActiveSoundsUpdated) {
									context.onActiveSoundsUpdated();
								}
								break;
							}
						}

						if (
							vttConfig.filter((item: any) => item.end < currentTime).length ===
							vttConfig.length
						) {
							clearInterval(newInterval.interval);
							SoundManager.currentCaption = null;
							if (context.onActiveSoundsUpdated) {
								context.onActiveSoundsUpdated();
							}
						}
					}, 200);
					context.activeSoundIntervals.push(newInterval);
				});
			});
		}

		context.activeSounds.push(activeSound);

		if(context.onActiveSoundsUpdated) {
			context.onActiveSoundsUpdated();
		}
	}

	stopSound(soundId: string): void {
    	for(var indx = 0; indx < this.activeSounds.length; indx++) {
			if(this.activeSounds[indx].id === soundId) {
				this.onRemoveSoundFromDOM(this.activeSounds[indx].id);
				this.activeSounds.splice(indx);
				break;
			}
		}

		if(this.onActiveSoundsUpdated) {
			this.onActiveSoundsUpdated();
		}
	}

	stopAllSounds(): void {
		for(var indx = this.activeSoundIntervals.length - 1; indx >= 0; indx--) {
			clearInterval(this.activeSoundIntervals[indx].interval);
		}

    	for(var indx = this.activeSounds.length - 1; indx >= 0; indx--) {
			this.onRemoveSoundFromDOM(this.activeSounds[indx].id);
			this.activeSounds.splice(indx);
			SoundManager.currentCaption = null;
		}

		if(this.onActiveSoundsUpdated) {
			this.onActiveSoundsUpdated();
		}
	}

	render() {
    	throw new Error('render must be implemented');
	}

	protected onAppendSoundToDOM(sound: SoundProps): SoundRefType {
    	throw new Error('onAppendSoundToDOM must be implemented');
	}

	protected onRemoveSoundFromDOM(soundId: string): void {
	}

	private convertVttToJson(vttString: string) {
		return new Promise((resolve, reject) => {
		  var current: any = {};
		  var sections: any = [];
		  var start: any = false;
		  var vttArray: any = vttString.split("\n");
	  
		  //remove all lines at the end of file that are empty
		  for(var indx = vttArray.length - 1; indx >= 0; indx--) {
			  if(vttArray[indx].trim() === '') {
				  vttArray.splice(indx, 1);
			  }
			  else {
				   break;
			   }
		  }
		  for (var index = 0; index < vttArray.length; index++) {
				var line = vttArray[index];
				if (line.replace(/<\/?[^>]+(>|$)/g, "") === " ") {
				} else if (line.replace(/<\/?[^>]+(>|$)/g, "").trim() == "") {
				} else if (line.indexOf("-->") !== -1) {
			  start = true;
	  
			  if (current.start) {
						sections.push(this.clone(current));
			  }
	  
			  current = {
						start: this.timeString2ms(
				  line.split("-->")[0].trimRight().split(" ").pop()
						),
						end: this.timeString2ms(
				  line.split("-->")[1].trimLeft().split(" ").shift()
						),
						part: "",
			  };
				} else if (line.replace(/<\/?[^>]+(>|$)/g, "").trim() === "") {
				} else if (line.replace(/<\/?[^>]+(>|$)/g, "") === " ") {
				} else {
			  if (start) {
						if (sections.length !== 0) {
				  if (
								sections[sections.length - 1].part.replace(
					  /<\/?[^>]+(>|$)/g,
					  ""
								) === line.replace(/<\/?[^>]+(>|$)/g, "")
				  ) {
				  } else {
								if (current.part.length === 0) {
					  current.part = line;
								} else {
					  current.part = `${current.part} ${line}`;
								}
								// If it's the last line of the subtitles
								if (index === vttArray.length - 1) {
					  sections.push(this.clone(current));
								}
				  }
						} else {
				  current.part = line;
				  sections.push(this.clone(current));
				  current.part = "";
						}
			  }
				}
		  }
	  
		  current = [];
	  
		  for (var indx = 0; indx < sections.length; indx++) {
				sections[indx].part = sections[indx].part.replace(/<\/?[^>]+(>|$)/g, "");
		  }
		  resolve(sections);
		});
	  }

	  private clone(obj: any) {
		if (null == obj || "object" != typeof obj) return obj;
		var copy = obj.constructor();
		for (var attr in obj) {
		  if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
		}
		return copy;
	  }

	  private timeString2ms(a: any, b?: any) {
		return (
		  (a = a.split(".")),
		  (b = a[1] * 1 || 0),
		  (a = a[0].split(":")),
		  b +
			(a[2]
			  ? a[0] * 3600 + a[1] * 60 + a[2] * 1
			  : a[1]
			  ? a[0] * 60 + a[1] * 1
			  : a[0] * 1) *
			  1e3
		);
	  }
}

export interface ActiveSound<RefType> {
	id: string;
	currentCaption: string;
	reference: RefType;
}

interface ActiveSoundInterval {
	id: string;
	interval?: any;
}